import {
  orderStatuses,
  orderTypes,
  artworkDocumentTypes,
  artworkDocumentTypesDescriptions,
  artworkStatuses,
  customerArtworkStatuses,
  addressType,
  contactType,
  contactDepartment,
  creditStatus,
  noteType,
  roles,
  serviceCode,
  poTypes,
  purchaseOrderFormPOTypes,
  storeCountries,
  storeCountriesStates,
  zipValidators
} from '@/constants';

const constantsMixin = {
  computed: {
    orderStatuses,
    orderTypes,
    artworkDocumentTypes,
    artworkDocumentTypesDescriptions,
    artworkStatuses,
    customerArtworkStatuses,
    addressType,
    contactType,
    contactDepartment,
    creditStatus,
    noteType,
    roles,
    serviceCode,
    poTypes,
    purchaseOrderFormPOTypes,
    storeCountries,
    storeCountriesStates,
    zipValidators
  }
};

export { constantsMixin as default };
